import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import ActivateWeb from "@/pages/ActivateWeb";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminPanel from "@/pages/AdminPanel";
import Privacy from "@/pages/Privacy";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/landing" element={<Landing />} />
        <Route path="/activate-web" element={<ActivateWeb />} />
        <Route path="/activate" element={<ActivateWeb />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/panel-8x3k" element={<AdminPanel />} />
        <Route path="*" element={<Navigate to="/landing" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
